/* ============================================================
   impressed — buying experience driver
   - FIRST10 copy chip (clipboard + feedback)
   - PDP savings pill: live update on variant change
   - Sticky buy bar: appears once the main buy button scrolls
     away; proxies the real product form submit
   - Cart top-up: AJAX add + Dawn-style drawer re-render
   ============================================================ */
(function () {
  'use strict';

  function fmt(cents) {
    var v = cents / 100;
    return '₹' + v.toLocaleString('en-IN', {
      minimumFractionDigits: cents % 100 === 0 ? 0 : 2,
      maximumFractionDigits: 2
    });
  }

  /* ---------- copy code ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lux-copy]');
    if (!btn) return;
    var code = btn.getAttribute('data-lux-copy');
    function done() {
      var wrap = btn.closest('.lux-offer');
      var doneEl = wrap ? wrap.querySelector('.lux-offer__done') : null;
      var hintEl = wrap ? wrap.querySelector('.lux-offer__hint') : null;
      if (doneEl) doneEl.hidden = false;
      if (hintEl) hintEl.hidden = true;
      window.setTimeout(function () {
        if (doneEl) doneEl.hidden = true;
        if (hintEl) hintEl.hidden = false;
      }, 1800);
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(code).then(done).catch(done);
    } else {
      var ta = document.createElement('textarea');
      ta.value = code;
      document.body.appendChild(ta);
      ta.select();
      try { document.execCommand('copy'); } catch (err) {}
      document.body.removeChild(ta);
      done();
    }
  });

  /* ---------- savings pill + sticky bar (product pages) ---------- */
  var savingsEl = document.getElementById('LuxSavings');
  var submitBtn = document.querySelector('.product-form__submit');

  function renderSavings(price, compare) {
    if (!savingsEl) return;
    if (compare && compare > price) {
      var sv = compare - price;
      var pct = Math.round((sv * 100) / compare);
      savingsEl.innerHTML = 'You save <strong>' + fmt(sv) + '</strong> (' + pct + '%) on this oil';
      savingsEl.hidden = false;
    } else {
      savingsEl.hidden = true;
    }
  }

  var bar = null;
  var barPrice = null;
  if (submitBtn) {
    var titleEl = document.querySelector('.product__title h1, .product__title');
    var imgEl = document.querySelector('.product__media-item.is-active img, .product__media-item img, .product__media img');
    bar = document.createElement('div');
    bar.id = 'lux-sticky-bar';
    bar.setAttribute('aria-hidden', 'true');
    var imgHtml = imgEl ? '<img src="' + (imgEl.currentSrc || imgEl.src) + '" alt="">' : '';
    bar.innerHTML =
      imgHtml +
      '<div class="lux-bar__meta"><span class="lux-bar__title">' +
      (titleEl ? titleEl.textContent.trim() : 'impressed') +
      '</span><span class="lux-bar__price"></span></div>' +
      '<button type="button" class="lux-bar__btn">Add to Cart</button>';
    document.body.appendChild(bar);
    barPrice = bar.querySelector('.lux-bar__price');
    if (savingsEl) barPrice.textContent = fmt(parseInt(savingsEl.getAttribute('data-price') || '0', 10));
    var barBtn = bar.querySelector('.lux-bar__btn');
    barBtn.addEventListener('click', function () {
      if (!submitBtn.disabled) submitBtn.click();
    });
    if (submitBtn.disabled) barBtn.disabled = true;

    var buyVisible = true;
    var footerVisible = false;
    function refreshBar() {
      var locked = document.body.classList.contains('overflow-hidden');
      var show = !buyVisible && !footerVisible && !locked;
      bar.classList.toggle('lux-bar-show', show);
      bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    }
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function (entries) {
        buyVisible = entries[0].isIntersecting;
        refreshBar();
      }, { threshold: 0 }).observe(submitBtn);
      var footerGroup = document.querySelector('.shopify-section-group-footer-group');
      if (footerGroup) {
        new IntersectionObserver(function (entries) {
          footerVisible = entries[0].isIntersecting;
          refreshBar();
        }, { threshold: 0 }).observe(footerGroup);
      }
    }
    new MutationObserver(refreshBar).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, function (payload) {
      var v = payload && payload.data ? payload.data.variant : null;
      if (!v) return;
      renderSavings(v.price, v.compare_at_price);
      if (barPrice) barPrice.textContent = fmt(v.price);
      if (bar) {
        var b = bar.querySelector('.lux-bar__btn');
        if (b) b.disabled = !v.available;
      }
    });
  }

  /* ---------- cart top-up add ---------- */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-lux-add]');
    if (!btn || btn.disabled) return;
    var vid = btn.getAttribute('data-lux-add');
    var inDrawer = !!btn.closest('#CartDrawer');
    btn.disabled = true;
    var original = btn.textContent;
    btn.textContent = 'Adding…';
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({
        items: [{ id: parseInt(vid, 10), quantity: 1 }],
        sections: ['cart-drawer', 'cart-icon-bubble'],
        sections_url: window.location.pathname
      })
    })
      .then(function (r) { return r.json(); })
      .then(function (data) {
        if (!data || !data.sections) throw new Error('no sections');
        var parsed = new DOMParser().parseFromString(data.sections['cart-drawer'], 'text/html');
        var current = document.querySelector('#CartDrawer .drawer__inner');
        var fresh = parsed.querySelector('.drawer__inner');
        if (current && fresh) current.innerHTML = fresh.innerHTML;
        var drawer = document.querySelector('cart-drawer');
        if (drawer) {
          drawer.classList.remove('is-empty');
          if (!inDrawer && typeof drawer.open === 'function') drawer.open();
        }
        var bubbleHtml = data.sections['cart-icon-bubble'];
        if (bubbleHtml) {
          var parsedB = new DOMParser().parseFromString(bubbleHtml, 'text/html');
          var freshB = parsedB.querySelector('#cart-icon-bubble');
          var curB = document.getElementById('cart-icon-bubble');
          if (freshB && curB) {
            curB.innerHTML = freshB.innerHTML;
            curB.setAttribute('class', freshB.getAttribute('class') || '');
          }
        }
      })
      .catch(function () {
        btn.disabled = false;
        btn.textContent = original;
      });
  });
})();
